import {
  Box,
  Container,
  Grid2,
  Typography,
  IconButton,
  Link as MuiLink,
} from "@mui/material";
import { Link } from "react-scroll";
import { Facebook, Twitter, Instagram, Linkedin, Truck } from "lucide-react";

const footerLinks = {
  Company: [{ name: "About Us", to: "about", isScroll: true }],
  Legal: [
    { name: "Privacy Policy", to: "/privacy-policy", isScroll: false },
    { name: "Terms of Service", to: "/terms-and-condition", isScroll: false },
  ],
  "Quick Links": [
    { name: "FAQs", to: "faqs", isScroll: true },
    { name: "Contact Us", to: "contact", isScroll: true },
    { name: "How It Works", to: "how-it-works", isScroll: true },
  ],
};

export default function Footer() {
  const renderLink = (link) => {
    if (link.isScroll) {
      return (
        <Link
          key={link.name}
          to={link.to}
          smooth={true}
          duration={500}
          style={{ cursor: "pointer" }}
        >
          <Typography
            sx={{
              display: "block",
              mb: 1,
              color: "text.secondary",
              "&:hover": {
                color: "primary.main",
                cursor: "pointer",
              },
              transition: "color 0.3s ease",
            }}
          >
            {link.name}
          </Typography>
        </Link>
      );
    }
    return (
      <MuiLink
        key={link.name}
        href={link.to}
        underline="hover"
        sx={{
          display: "block",
          mb: 1,
          color: "text.secondary",
          "&:hover": { color: "primary.main" },
          transition: "color 0.3s ease",
        }}
      >
        {link.name}
      </MuiLink>
    );
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        color: "text.primary",
        pt: 8,
        pb: 4,
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)",
        },
      }}
    >
      <Container>
        <Grid2 container spacing={4} justifyContent={"center"}>
          {/* Logo and Social Links */}
          <Grid2 item size={{ xs: 12, md: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Truck size={32} color="#00ADB5" />
              <Typography variant="h6" sx={{ ml: 1, color: "#00ADB5" }}>
                RSC 2025
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
              Revolutionizing supply chain management with innovative solutions
              and rewards.
            </Typography>
            {/* <Box sx={{ mb: 3 }}>
              <IconButton color="primary">
                <Facebook size={20} />
              </IconButton>
              <IconButton color="primary">
                <Twitter size={20} />
              </IconButton>
              <IconButton color="primary">
                <Instagram size={20} />
              </IconButton>
              <IconButton color="primary">
                <Linkedin size={20} />
              </IconButton>
            </Box> */}
          </Grid2>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <Grid2 item size={{ xs: 12, sm: 12, md: 2 }} key={category}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ color: "white", fontWeight: 600 }}
              >
                {category}
              </Typography>
              {links.map((link) => renderLink(link))}
            </Grid2>
          ))}
        </Grid2>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: 1,
            borderColor: "divider",
            mt: 8,
            pt: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} RSC. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
